import { Injectable } from '@angular/core';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { NavigationItem } from './navigation-item.interface';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationLoaderService {
  private readonly _items: BehaviorSubject<NavigationItem[]> =
    new BehaviorSubject<NavigationItem[]>([]);

  get items$(): Observable<NavigationItem[]> {
    return this._items.asObservable();
  }

  constructor(private readonly layoutService: VexLayoutService) {
    this.loadNavigation();
  }

  loadNavigation(): void {
    this._items.next([
      {
        type: 'link',
        label: 'Inicio',
        route: '/',
        icon: 'mat:dashboard',
        routerLinkActiveOptions: { exact: true }
      },
      {
        type: 'dropdown',
        label: 'CRM',
        icon: 'mat:people',
        children: [
          {
            type: 'link',
            label: 'Clientes',
            route: '/crm/clientes',
            icon: 'mat:person_search'
          },
          {
            type: 'link',
            label: 'Leads',
            route: '/crm/leads',
            icon: 'mat:person_add'
          }
        ]
      },
      {
        type: 'dropdown',
        label: 'Administración',
        icon: 'mat:admin_panel_settings',
        children: [
          {
            type: 'link',
            label: 'Usuarios',
            route: '/admin/usuarios',
            icon: 'mat:people'
          },
          {
            type: 'link',
            label: 'Áreas y Cargos',
            route: '/admin/areas',
            icon: 'mat:business'
          },
          {
            type: 'link',
            label: 'Parámetros',
            route: '/admin/parametros',
            icon: 'mat:settings'
          },
          {
            type: 'link',
            label: 'Procesador de Pagos',
            route: '/procesador-pagos/lista',
            icon: 'mat:payments'
          }
        ]
      },
      {
        type: 'link',
        label: 'Cartera',
        route: '/cartera/general',
        icon: 'mat:account_balance_wallet'
      },
      {
        type: 'dropdown',
        label: 'Back Office',
        icon: 'mat:work',
        children: [
          {
            type: 'link',
            label: 'Dispute Center',
            route: '/disputas/cuentas',
            icon: 'mat:gavel'
          },
          {
            type: 'link',
            label: 'IdentityIQ',
            route: '/identityiq/lista',
            icon: 'mat:shield'
          },
          {
            type: 'link',
            label: 'Auditor IA',
            route: '/auditor/lista',
            icon: 'mat:record_voice_over'
          }
        ]
      },
      {
        type: 'dropdown',
        label: 'Opciones',
        icon: 'mat:settings',
        children: [
          {
            type: 'link',
            label: 'Soporte',
            route: '/opciones/soporte',
            icon: 'mat:list',
          }
        ]
      },
      {
        type: 'dropdown',
        label: 'Consultas',
        icon: 'mat:analytics',
        children: [
          {
            type: 'link',
            label: 'Dashboard Reportes',
            route: '/consultas/dashboard',
            icon: 'mat:analytics'
          },
          {
            type: 'link',
            label: 'Cartera por Agente',
            route: '/consultas/cartera-agente',
            icon: 'mat:people'
          }
        ]
      },
      {
        type: 'dropdown',
        label: 'Agenda',
        icon: 'mat:event',
        children: [
          {
            type: 'link',
            label: 'Todas las Citas',
            route: '/agenda/citas',
            icon: 'mat:event'
          },
          {
            type: 'link',
            label: 'Panel SAC',
            route: '/agenda/panel-sac',
            icon: 'mat:support_agent'
          },
          {
            type: 'link',
            label: 'Panel Ventas',
            route: '/agenda/panel-ventas',
            icon: 'mat:storefront'
          }
        ]
      },
      {
        type: 'dropdown',
        label: 'Comunicaciones',
        icon: 'mat:forum',
        children: [
          {
            type: 'link',
            label: 'SMS',
            route: '/comunicaciones/sms',
            icon: 'mat:sms'
          },
          {
            type: 'link',
            label: 'Email',
            route: '/comunicaciones/email',
            icon: 'mat:email'
          }
        ]
      },
      {
        type: 'dropdown',
        label: 'BI',
        icon: 'mat:insights',
        children: [
          {
            type: 'link',
            label: 'Dashboard BI',
            route: '/bi/dashboard',
            icon: 'mat:insights'
          },
          {
            type: 'link',
            label: 'Productividad Agentes',
            route: '/bi/agentes',
            icon: 'mat:people'
          }
        ]
      },
    ]);
  }
}
